import {Pipe, PipeTransform} from "@angular/core";
import {Temporal} from "temporal-polyfill";
import {TemporalFormatering, ZonedDateTimeFormat} from "../tjenester/TemporalFormatering";
import {lesDateEllerZonedDateTimeSerialisert, lesZonedDateTimeSerialisertOpt} from "felles-ng2/støttefunksjoner/temporal";
import {ZonedDateTimeSerialisert} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import ZonedDateTime = Temporal.ZonedDateTime;
import {dateSomZonedDateTime} from "felles-ng2/støttefunksjoner/temporalTilDateKonverteringer";
import {erStreng} from "felles-ng2/støttefunksjoner/strenger";

/**
 * Formaterer ZonedDateTime instanser.
 *
 * Angitt dato kan være av typen ZonedDateTime, ZonedDateTimeSerialisert eller Date
 * Format kan angis som argument nr 2,
 * 'short' gir '11.07.2014, 12:01', 'medium' gir '11. juli 2014, 12:01' og 'long' gir 'fredag 11. juli 2014 kl. 12:01'.
 * Tidssone skrives ut dersom tredje argument er satt til true, og resulterer da i '11. juli 2014 kl. 12:01 (CET)'
 *
 * Eksempler:
 * `{{ enDato|zoneddatetime:'medium' }}`
 * `{{ enDato|zoneddatetime:{year: 'numeric', month: 'short'} }}`
 * `{{ enDato|zoneddatetime:'medium':true }}`
 *
 * Se tester TemporalFormatering.jestspec.ts for eksempler på ulike formater.
 */
@Pipe({name: 'zoneddatetime', pure: true, standalone: true})
export class FormaterZonedDateTimePipe implements PipeTransform {
    constructor(private formatering: TemporalFormatering) {
    }

    transform(datoOgKlokkeslett: ZonedDateTime | ZonedDateTimeSerialisert | Date | null, format: ZonedDateTimeFormat = 'short', visTidssone = false): string | null {
        return this.formatering.formaterZonedDateTime(
          (datoOgKlokkeslett instanceof ZonedDateTime) ? datoOgKlokkeslett : lesDateEllerZonedDateTimeSerialisert(datoOgKlokkeslett),
          format,
          visTidssone);
    }
}
